import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { EmailSignInForm } from "../components/EmailSignInForm.js";
import { invitesApi } from "../lib/api/invites.js";
import "./Login.css";

type State =
  | { kind: "loading" }
  | { kind: "valid"; inviterName: string | null }
  | { kind: "invalid" };

export function InviteLanding() {
  const { code = "" } = useParams();
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    let cancelled = false;
    invitesApi.preview(code).then((r) => {
      if (cancelled) return;
      if (r.success && r.data?.valid) {
        setState({ kind: "valid", inviterName: r.data.inviterName });
      } else {
        setState({ kind: "invalid" });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <main className="login">
      <div className="login__card">
        <Link to="/" className="brand brand--ink login__brand">
          <img src="/tatu.svg" alt="" aria-hidden="true" width={32} height={32} />
          Ondetatu
        </Link>

        {state.kind === "loading" && <p className="login__sub">Checking your invite…</p>}

        {state.kind === "invalid" && (
          <>
            <h1 className="login__title">This invite isn't valid</h1>
            <p className="login__sub">
              It may have expired or already been used. Ask your friend for a fresh one.
            </p>
            <Link className="btn btn-ghost-ink" to="/">
              Go home
            </Link>
          </>
        )}

        {state.kind === "valid" && (
          <>
            <h1 className="login__title">
              {state.inviterName ? `${state.inviterName} invited you 🦫` : "You're invited 🦫"}
            </h1>
            <p className="login__sub">
              Ondetatu is a private, invite-only map of where your people are. Enter your email to
              join — we'll send you a sign-in link and connect you automatically.
            </p>
            <EmailSignInForm inviteCode={code} cta="Continue with email" />
          </>
        )}
      </div>
    </main>
  );
}
